import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=4d72974f&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=4d72974f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72974f",
  null
  
)

export default component.exports